<template>
  <div>
    <page-title-bar></page-title-bar>
    <receipt-image
      :dialog.sync="openReceiptModal"
      ref="receiptModal"
    ></receipt-image>
    <v-container fluid grid-list-xl pt-0>
      <v-layout row wrap>
        <app-card :fullBlock="true" colClasses="xs12">
          <v-card-title>
            <v-btn
              color="primary"
              :loading="refreshLoading"
              fab
              icon
              small
              outline
              @click="refreshShoppings"
            >
              <v-icon class="zmdi zmdi-refresh-sync"></v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-text-field
              append-icon="search"
              hide-details
              :label="$t('message.search')"
              single-line
              v-model="search"
            ></v-text-field>
          </v-card-title>

          <v-data-table
            :headers="headers"
            :items="licenseSalesArray"
            :search="search"
            :pagination.sync="pagination"
          >
            <template slot="headerCell" slot-scope="props">
              <v-tooltip bottom>
                <span slot="activator">{{
                  $t(`message.${props.header.text}`)
                }}</span>
                <span>{{ $t(`message.${props.header.text}`) }}</span>
              </v-tooltip>
            </template>
            <template slot="items" slot-scope="props">
              <!-- <td class="text-center">{{ props.item.code }}</td> -->
              <td class="text-center">
                <v-btn
                  color="light-green accent-4"
                  round
                  outline
                  small
                  v-if="props.item.status === 'PAID'"
                  :to="`license-sales/${props.item.id}`"
                  >{{ $t("message.verified") }}</v-btn
                >

                <v-btn
                  color="error"
                  round
                  outline
                  small
                  v-else-if="props.item.status === 'REJECTED'"
                  :to="`license-sales/${props.item.id}`"
                  >{{ $t("message.cancelled") }}</v-btn
                >

                <v-btn
                  color="yellow"
                  round
                  outline
                  small
                  v-else-if="props.item.status === 'PENDING'"
                  :to="`license-sales/${props.item.id}`"
                  >{{ $t("message.pending") }}</v-btn
                >
                <v-btn
                  color="amber"
                  round
                  outline
                  small
                  v-else-if="props.item.status === 4"
                  :to="`license-sales/${props.item.id}`"
                  >{{ $t("message.verify") }}</v-btn
                >
              </td>
              <td>{{fullName(props.item.user)}}</td>
              <td>{{props.item.user.email}}</td>
              <td>{{props.item.user.phone}}</td>
              <td>{{ props.item.updated_at }}</td>
              <td class="text-left">
                <v-tooltip top>
                  <v-btn
                    color="primary"
                    fab
                    icon
                    small
                    slot="activator"
                    outline
                    :to="`license-sales/${props.item.id}`"
                  >
                    <v-icon light>search</v-icon>
                  </v-btn>
                  <span>{{ $t("message.details") }}</span>
                </v-tooltip>
                <v-tooltip top>
                  <v-btn
                    @click="onReceipt(props.item)"
                    color="amber"
                    fab
                    icon
                    small
                    outline
                    slot="activator"
                  >
                    <v-icon light>zmdi-collection-image-o</v-icon>
                  </v-btn>
                  <span>{{ $t("message.receiptImage") }}</span>
                </v-tooltip>
              </td>
            </template>
          </v-data-table>
        </app-card>
      </v-layout>
    </v-container>
    <user-message
      :broadcast="broadcast"
      :dialog.sync="showSendMessage"
      ref="userMessage"
    ></user-message>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { userRoles, purchaseStatus } from "../../constants/constants";
import UserMessage from "../telegramUsers/UserMessage";
import ReceiptImage from "../shopping/ReceiptImage";
import PurchaseStatusButton from "../custom/PurchaseStatusButton";
import { GET_LICENSE_SALES } from "../../store/modules/licenseSales/actionTypes";

export default {
  name: "salesList",
  components: {
    ReceiptImage,
    UserMessage,
    PurchaseStatusButton,
  },
  data() {
    return {
      search: "",
      openReceiptModal: false,
      showSendMessage: false,
      refreshLoading: false,
      broadcast: false,
      headers: [
        // { text: "code", align: "center", sortable: true, value: "code" },
        {
          text: "status",
          align: "center",
          sortable: true,
          value: "status",
        },
        { text: "client", sortable: true, value: "ticket_user.fullName" },
        { text: "email", sortable: true, value: "ticket_user.email" },
        { text: "telephone", sortable: true, value: "ticket_user.phone" },
        { text: "lastUpdate", sortable: true, value: "updated_at" },
        // { text: "rating", sortable: true, value: "rating" },
        { text: "actions", sortable: false, value: "" },
      ],
      purchaseStatus: purchaseStatus,
      userRoles: userRoles,
      pagination: {
        descending: true,
        sortBy: "updated_at",
        rowsPerPage: 10,
      },
    };
  },
  computed: {
    ...mapGetters(["licenseSalesArray"]),
    userRole() {
      const { role_id } = JSON.parse(localStorage.getItem("userData"));
      return role_id;
    },
  },
  created() {
    this[GET_LICENSE_SALES]();
  },
  methods: {
    ...mapActions([GET_LICENSE_SALES]),
    fullName(userData){
      if(!userData) {
        return '';
      }
      return userData?.name + ' ' + userData?.lastname
    },
    async refreshShoppings() {
      this.refreshLoading = true;
      await this[GET_LICENSE_SALES]();
      this.refreshLoading = false;
    },

    onReceipt(receipt) {
      this.$refs.receiptModal.setValue(receipt.image_url);
      this.openReceiptModal = true;
    },
    onSend(client) {
      let user = {
        id: client.client_id,
      };
      this.$refs.userMessage.setValue(user);
      (this.showSendMessage = true), (this.broadcast = false);
    },
    checkReceiptDetails(receipt) {
      this.$router.push({ name: "shoppingDetails", param: { id: receipt.id } });
    },
  },
};
</script>

